import { render, staticRenderFns } from "./contact-info.vue?vue&type=template&id=f72eaf9c&scoped=true&"
import script from "./contact-info.vue?vue&type=script&lang=js&"
export * from "./contact-info.vue?vue&type=script&lang=js&"
import style0 from "./contact-info.vue?vue&type=style&index=0&id=f72eaf9c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../tmp/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f72eaf9c",
  null
  
)

export default component.exports